/** Still image for a /clips card: the saved cover, else the rendered
 *  thumbnail, else the source thumbnail, skipping any that failed to load.
 *  An image instead of a <video> per card: iPhone Safari shows a video with
 *  no poster as black, and 24 cards would each fetch video metadata. */
export function resolveClipCardPoster({
  coverUrl,
  finishedThumbnailUrl,
  thumbnailUrl,
  failedUrls,
}: {
  coverUrl: string | null | undefined;
  finishedThumbnailUrl: string | null | undefined;
  thumbnailUrl: string | null | undefined;
  failedUrls: ReadonlySet<string>;
}): string | null {
  for (const url of [coverUrl, finishedThumbnailUrl, thumbnailUrl]) {
    if (url && !failedUrls.has(url)) return url;
  }
  return null;
}

export type ClipPreviewOrientation = 'portrait' | 'landscape';

/** Shape of the preview dialog, from the poster's natural size. Clips are
 *  vertical unless the image proves otherwise. */
export function resolveClipPreviewOrientation(
  size: { width: number; height: number } | null,
): ClipPreviewOrientation {
  if (!size || size.width <= 0 || size.height <= 0) return 'portrait';
  return size.width > size.height ? 'landscape' : 'portrait';
}
